export default __webpack_public_path__ + "static/media/em_lsleeve_2.e9d15d85.webp";